var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyanPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 28,
    viewBox: "0 0 114 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_316_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.4953H57V-0.000109092H5.08929L0 5.38813L0 11.4953Z",
    fill: "url(#paint0_linear_316_2)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_316_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 6.91475C5.79514 4.59866 4.94034 5.45778 7.17298 3.14169L34.8557 3.14169",
    stroke: "#D3F5EE",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4953H57V21.1825H5.08929L0 15.7943L0 10.4953Z",
    fill: "url(#paint1_linear_316_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 11.4953H57V-0.000109092H108.911L114 5.38813L114 11.4953Z",
    fill: "url(#paint2_linear_316_2)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_316_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.437 6.91475C108.205 4.59866 109.06 5.45778 106.827 3.14169L79.1443 3.14169",
    stroke: "#D3F5EE",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114 10.4953H57V21.1825H108.911L114 15.7943L114 10.4953Z",
    fill: "url(#paint3_linear_316_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_316_2",
    x: -4,
    y: -2.00012,
    width: 122,
    height: 29.1826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.917647 0 0 0 0 0.807843 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_316_2",
    x: 1.24014,
    y: 0.819322,
    width: 35.9379,
    height: 8.41778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.917647 0 0 0 0 0.807843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_316_2",
    x: 76.8219,
    y: 0.819322,
    width: 35.9379,
    height: 8.41778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.917647 0 0 0 0 0.807843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_2",
    x1: 28.5,
    y1: 11.4953,
    x2: 28.5,
    y2: -0.000108719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#199CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A8AA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_2",
    x1: 28.5,
    y1: 10.4953,
    x2: 28.5,
    y2: 21.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#199CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A8AA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_316_2",
    x1: 85.5,
    y1: 11.4953,
    x2: 85.5,
    y2: -0.000108719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#199CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A8AA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_316_2",
    x1: 85.5,
    y1: 10.4953,
    x2: 85.5,
    y2: 21.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#199CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A8AA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyanPanel);
export default __webpack_public_path__ + "static/media/cyan-panel.172776399e2bd248af1cc036e179e3c6.svg";
export { ForwardRef as ReactComponent };